import * as React from 'react';

import { Icon, Modal, Space, Text } from 'farmhub-ui-core';

import { useAppDispatch, useAppSelector } from 'app';
import { TitleText } from 'components';
import OrderTaskTabPane from 'containers/WarehouseOperation/OrderOperation/Order/Overview/DetailPage/OrderLogTab/OrderTaskTabPane';
import { cancelOrderTaskModal } from 'slice';
import { ORDER_TASK_TYPE } from 'utils';

import QRCodeSharingDesktop from './QRCodeSharing';
import { CTabs, ModalStyles, TabHeaderContentWrapper } from './styles';

const TAB_MODE = {
  ASSIGN: 'assign',
  INFO: 'info',
};

export const TabHeaderContent = ({
  icon,
  iconWidth,
  iconHeight,
  isActive,
  text,
}: {
  icon?: React.ReactNode;
  iconWidth?: number;
  iconHeight?: number;
  isActive: boolean;
  text: string;
}): JSX.Element => (
  <TabHeaderContentWrapper
    alignItems="center"
    iconHeight={iconHeight}
    iconWidth={iconWidth}
    isActive={isActive}
  >
    <Icon>{icon}</Icon>
    <Space height={4} />
    <Text
      color={isActive ? 'main' : 'secondary'}
      lineHeight="22px"
      size="xs"
      weight="bold"
    >
      {text}
    </Text>
  </TabHeaderContentWrapper>
);

const OrderTaskModal = (): JSX.Element => {
  const dispatch = useAppDispatch();
  const orderTaskModal = useAppSelector(state => state.orderTaskModal);
  const [activeTab, setActiveTab] = React.useState<string>(TAB_MODE.ASSIGN);

  const handleCancelModal = () => {
    dispatch(cancelOrderTaskModal());
    setActiveTab(TAB_MODE.ASSIGN);
  };

  const handleSelectTab = (activeKey: string): void => {
    setActiveTab(activeKey);
  };

  return (
    <Modal
      centered
      destroyOnClose
      bodyHeight="615px"
      displayFooter={false}
      styles={ModalStyles}
      title={
        <TitleText>
          {orderTaskModal?.data?.type === ORDER_TASK_TYPE.PURCHASE_ORDER
            ? 'Phân công đơn nhập hàng:'
            : 'Phân công đơn hàng:'}{' '}
          <Text color="main" size="xxs" textTransform="uppercase" weight="bold">
            {orderTaskModal.data.customerName}
          </Text>
        </TitleText>
      }
      visible={orderTaskModal.visible}
      width="520px"
      onCancel={handleCancelModal}
    >
      <CTabs
        destroyInactiveTabPane
        activeKey={activeTab}
        onChange={handleSelectTab}
      >
        <CTabs.TabPane
          key={`${TAB_MODE.ASSIGN}`}
          tab={
            <TabHeaderContent
              iconWidth={18}
              isActive={activeTab === `${TAB_MODE.ASSIGN}`}
              text="Danh sách"
            />
          }
        >
          {orderTaskModal.visible && (
            <OrderTaskTabPane
              isOrderLoading={false}
              orderID={orderTaskModal?.data?.orderID ?? ''}
              query={orderTaskModal?.data ?? ''}
            />
          )}
        </CTabs.TabPane>
        <CTabs.TabPane
          key={`${TAB_MODE.INFO}`}
          tab={
            <TabHeaderContent
              iconWidth={18}
              isActive={activeTab === `${TAB_MODE.INFO}`}
              text="Chia sẻ"
            />
          }
        >
          <QRCodeSharingDesktop order={orderTaskModal?.data} />
        </CTabs.TabPane>
      </CTabs>
    </Modal>
  );
};
export default OrderTaskModal;
